import { render, staticRenderFns } from "./solicitud-material-detalle.vue?vue&type=template&id=fc6a9ff2"
import script from "./solicitud-material-detalle.vue?vue&type=script&lang=js"
export * from "./solicitud-material-detalle.vue?vue&type=script&lang=js"
import style0 from "./solicitud-material-detalle.vue?vue&type=style&index=0&id=fc6a9ff2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports